import React, { useMemo } from "react";
import { TableListing } from "../../../../../components/AppListing/TableListing";
import ListIcon from "../../../../../components/listIcon";

function FacilityGroupListing({
  groups = [],
  groupsLoading = false,
  onEdit = () => {},
  onDelete = () => {},
  deletingGroup = false,
}) {


    const cols = useMemo(() => [
        {
            title: "Group Name",
            key: "name",
            colClass: "flex text-left",
            getData: (item) => item?.group_name || item?.name || "-",
        },
        {
            title: "Locations",
            key: "locations",
            colClass: "flex text-left",
            getData: (item) => {
                if (Array.isArray(item?.locations) && item.locations.length) {
                    return item.locations.map((loc) => loc?.name).filter(Boolean).join(", ");
                }
                if (item?.location_names) return item.location_names;
                if (item?.location_name) return item.location_name;
                return "-";
            },
        },
        {
            title: "Total Locations",
            key: "total_locations",
            colClass: "flex text-left",
            getData: (item) => {
                return item?.locations?.length || 0;
            },
        },
        {
            title: "Actions",
            key: "actions",
            colClass: "flex text-center justify-center items-center",
            align: "center",
            skipColHtmlTooltip: true,
            getData: (item) => {
                return (
                    <div className="flex gap-2 items-center justify-center h-[100%]">
                        <ListIcon
                            title="Edit"
                            handler={() => onEdit(item)}
                            type="edit"
                            disabled={deletingGroup}
                        />
                        <ListIcon
                            title="Delete"
                            handler={() => onDelete(item)}
                            type="remove"
                            disabled={deletingGroup}
                        />
                    </div>
                );
            },
        },
    ], [onEdit, onDelete, deletingGroup]);

    return (
        <div className="px-3 mt-2 w-full h-[calc(100vh-130px)] overflow-y-auto shadow-md">
            <TableListing
                listData={groups || []}
                cols={cols || []}
                loading={groupsLoading || false}
            />
        </div>
    );
}

export default FacilityGroupListing;
